require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-introducing-rob-wills.json") })
        }
      }, "path---authors-introducing-rob-wills");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-introducing-rob-wills!./.cache/json/authors-introducing-rob-wills.json
// module id = 1291
// module chunks = 231608221292675